import React from "react";

//Images
import poolDecks from "../images/knowledge/water-drop.svg";
import permeablePavers from "../images/knowledge/wave.svg";
import driveway from "../images/knowledge/truck.svg";
import drainage from "../images/knowledge/drain.svg";
import outdoorLighting from "../images/knowledge/tungsten-light.svg";
import segmentalWalls from "../images/knowledge/brickwall.svg";
import retainingWalls from "../images/knowledge/stairs.svg";
import firepits from "../images/knowledge/bonfire.svg";

const Knowledge = () => {
  const items = [
    {
      title: "Slip Resistant Pool Decks",
      image: poolDecks,
    },
    {
      title: "Permeable Pavers",
      image: permeablePavers,
    },
    {
      title: "Driveway Construction",
      image: driveway,
    },
    {
      title: "Drainage",
      image: drainage,
    },
    {
      title: "Outdoor Lighting",
      image: outdoorLighting,
    },
    {
      title: "Building Segmental Walls",
      image: segmentalWalls,
    },
    {
      title: "Building Steps and Retaining Walls",
      image: retainingWalls,
    },
    {
      title: "Building Firepits",
      image: firepits,
    },
  ];

  const mapItems = () => {
    return items.map((item, index) => {
      return (
        <div className="col-6 col-lg-3 text-center mb-5" key={index}>
          <div className="image">
          <img src={item.image} alt={item.title} />
          </div>
          <p className="text-uppercase mt-3">{item.title}</p>
        </div>
      );
    });
  };

  return (
    <div className="row justify-content-center">
      <div className="col-11 col-xl-10 panel-knowledge">
        <div className="row">
          <div className="col-12 text-center">
            <h3 className="text-uppercase text-blue">
              Our crews have extensive knowledge in
            </h3>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-11 col-lg-10 col-xl-9">
            <div className="row justify-content-center mt-5">{mapItems()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Knowledge;
